import Flickity from 'flickity/dist/flickity.pkgd.min.js'

$('.dnk-carousel__ribbon').flickity({
  wrapAround: true,
  autoPlay: true,
  prevNextButtons: false,
  pageDots: false,
  selectedAttraction: 0.01,
  friction: 0.2
});
